
import TrakkenCard from '~/components/ui/TrakkenCard.vue'
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper'

export default {
  name: 'HooperSlider',
  props: {
    slides: {
      type: Array,
      required: true
    },
    navigation: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      hooperSettings: {
        itemsToShow: 4,
        infiniteScroll: false,
        wheelControl: false,
        trimWhiteSpace: true,
        breakpoints: {
          320: {
            itemsToShow: 1.25
          },
          768: {
            itemsToShow: 2.75
          },
          992: {
            itemsToShow: 4
          }
        }
      },
      hooper3Settings: {
        itemsToShow: 4,
        infiniteScroll: false,
        wheelControl: false,
        trimWhiteSpace: true,
        breakpoints: {
          320: {
            itemsToShow: 1.25
          },
          768: {
            itemsToShow: 2.75
          },
          992: {
            itemsToShow: 4
          }
        }
      },
      hooperGallerySettings: {
        itemsToShow: 3,
        infiniteScroll: true,
        wheelControl: false,
        trimWhiteSpace: true,
        breakpoints: {
          320: {
            itemsToShow: 1
          },
          768: {
            itemsToShow: 3
          },
          992: {
            itemsToShow: 3
          }
        }
      },
      animationClass: '',
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0.75, 0.75]
      }
    }
  },
  components: {
    TrakkenCard,
    Hooper,
    Slide,
    HooperNavigation
  },
  methods: {
    onSetAnimationClass({ going }) {
      console.log('SET ANIMATION', going)
      if (going === this.$waypointMap.GOING_IN && window.innerWidth > 992) {
        console.log('SET CLASSES')
        this.animationClass = 'animate__animated animate__fadeInUp'
      }
    }
  }
}
